import bagIconSource from "bootstrap-icons/icons/bag.svg?raw";
import gearIconSource from "bootstrap-icons/icons/gear.svg?raw";
import journalTextIconSource from "bootstrap-icons/icons/journal-text.svg?raw";
import questionCircleIconSource from "bootstrap-icons/icons/question-circle.svg?raw";
import trophyIconSource from "bootstrap-icons/icons/trophy.svg?raw";
import { MOUSE_POINTER_ICON_SVG_SOURCE } from "@/shared/ui/mousePointerIcon";

export type HoverIdleNavIconName =
  | "achievements"
  | "mpm"
  | "records"
  | "help"
  | "settings"
  | "shop";

const ICON_SOURCE: Readonly<Record<HoverIdleNavIconName, string>> = {
  achievements: trophyIconSource,
  mpm: MOUSE_POINTER_ICON_SVG_SOURCE,
  records: journalTextIconSource,
  help: questionCircleIconSource,
  settings: gearIconSource,
  shop: bagIconSource,
};

export function createHoverIdleNavIcon(
  name: HoverIdleNavIconName,
): HTMLElement {
  const wrapper = document.createElement("span");
  wrapper.className = "hover-idle-nav-icon";
  wrapper.dataset.icon = name;
  wrapper.setAttribute("aria-hidden", "true");

  const parsed = new DOMParser().parseFromString(
    ICON_SOURCE[name],
    "image/svg+xml",
  );
  const svg = document.importNode(parsed.documentElement, true);
  svg.setAttribute("focusable", "false");
  wrapper.append(svg);
  return wrapper;
}
